import DischargeService from "../../Services/DischargeService";

// ── Action Types ────────────────────────────────────────────────────────────
export const SET_DISCHARGE_FIELD = "SET_DISCHARGE_FIELD";
export const SET_DISCHARGE_NESTED_FIELD = "SET_DISCHARGE_NESTED_FIELD";
export const SET_DISCHARGE_ARRAY_ITEM = "SET_DISCHARGE_ARRAY_ITEM";
export const ADD_DISCHARGE_ARRAY_ITEM = "ADD_DISCHARGE_ARRAY_ITEM";
export const REMOVE_DISCHARGE_ARRAY_ITEM = "REMOVE_DISCHARGE_ARRAY_ITEM";
export const LOAD_DISCHARGE_SUMMARY_DATA = "LOAD_DISCHARGE_SUMMARY_DATA";
export const RESET_DISCHARGE_SUMMARY = "RESET_DISCHARGE_SUMMARY";

export const SAVE_DISCHARGE_REQUEST = "SAVE_DISCHARGE_REQUEST";
export const SAVE_DISCHARGE_SUCCESS = "SAVE_DISCHARGE_SUCCESS";
export const SAVE_DISCHARGE_FAILURE = "SAVE_DISCHARGE_FAILURE";

export const FETCH_DISCHARGE_REQUEST = "FETCH_DISCHARGE_REQUEST";
export const FETCH_DISCHARGE_SUCCESS = "FETCH_DISCHARGE_SUCCESS";
export const FETCH_DISCHARGE_FAILURE = "FETCH_DISCHARGE_FAILURE";

// ── Action Creators ─────────────────────────────────────────────────────────

export const setDischargeField = (field, value) => ({
  type: SET_DISCHARGE_FIELD,
  payload: { field, value },
});

export const setDischargeNestedField = (parent, field, value) => ({
  type: SET_DISCHARGE_NESTED_FIELD,
  payload: { parent, field, value },
});

export const addDischargeArrayItem = (arrayName, item) => ({
  type: ADD_DISCHARGE_ARRAY_ITEM,
  payload: { arrayName, item },
});

export const removeDischargeArrayItem = (arrayName, index) => ({
  type: REMOVE_DISCHARGE_ARRAY_ITEM,
  payload: { arrayName, index },
});

export const setDischargeArrayItem = (arrayName, index, field, value) => ({
  type: SET_DISCHARGE_ARRAY_ITEM,
  payload: { arrayName, index, field, value },
});

export const loadDischargeSummaryData = (data) => ({
  type: LOAD_DISCHARGE_SUMMARY_DATA,
  payload: data,
});

export const resetDischargeSummary = () => ({
  type: RESET_DISCHARGE_SUMMARY,
});

/**
 * Save or Update Discharge Summary Thunk
 */
export const saveDischargeSummaryAction = (payload, onSuccess) => async (dispatch) => {
  dispatch({ type: SAVE_DISCHARGE_REQUEST });
  console.log("================== DISCHARGE FINAL SAVE/UPDATE PAYLOAD ==================");
  console.log(JSON.stringify(payload, null, 2));
  console.log("Discharge Payload Object:", payload);
  console.log("=========================================================================");
return
  try {
    let res;
    if (payload.dischSummaryId) {
      // Update
      res = await DischargeService.updateDischargeSummary(payload.dischSummaryId, payload);
    } else {
      // Create / Save
      res = await DischargeService.saveDischargeSummary(payload);
    }
    dispatch({ type: SAVE_DISCHARGE_SUCCESS, payload: res?.data });
    if (onSuccess) onSuccess(res?.data);
    return res?.data;
  } catch (error) {
    console.error("Discharge Save Error:", error);
    dispatch({
      type: SAVE_DISCHARGE_FAILURE,
      payload: error?.response?.data?.message || error.message,
    });
  }
};
